export enum JobDisplay {
    Kanban = 'Kanban',
    List = 'List'
}
